import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { authenticationSelectors } from '@wam/authentication';
import { State } from '@wam/shared';
import { combineLatest, Observable } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationGuard {
  private store = inject<Store<State>>(Store);
  private router = inject(Router);

  canActivate(): Observable<boolean> {
    return combineLatest([
      this.store.pipe(
        select(authenticationSelectors.getCurrentUser),
        map((user) => !!user),
      ),
    ]).pipe(
      tap(([isLoggedIn]) => {
        if (!isLoggedIn) {
          this.router.navigateByUrl(`/login`);
        }
      }),
      map(([isLoggedIn]) => isLoggedIn),
      take(1),
    );
  }

  canLoad(): Observable<boolean> {
    return this.canActivate();
  }
}
